import { apiClient } from "../../../services/apiClient";
import { ProfileResponse } from "../Interfaces/ProfileTypes";

export async function getProfile(employeeId: string): Promise<ProfileResponse> {
  const { data } = await apiClient.get<ProfileResponse>(`/profile/${employeeId}`);
  return data;
}
